/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusComplianceVisibilityDto } from '../../models/lexplus-compliance-visibility-dto';

export interface ComplianceControllerGetVisibilityV1$Params {
}

export function complianceControllerGetVisibilityV1(http: HttpClient, rootUrl: string, params?: ComplianceControllerGetVisibilityV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusComplianceVisibilityDto>> {
  const rb = new RequestBuilder(rootUrl, complianceControllerGetVisibilityV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusComplianceVisibilityDto>;
    })
  );
}

complianceControllerGetVisibilityV1.PATH = '/v1/compliance/visibility';
